export default {
    items: [],
    fields: [
        {
            key: "id",
            label: "#",
            sorter: false,
            filter: false,
            _style: "width:10%",
        },
        {
            key: "name",
            label: "name",
            sorter: false,
            filter: false,
            _style: "width:40%",
        },
        {
            key: "email",
            label: "email",
            sorter: false,
            filter: false,
            _style: "width:40%",
        },
    ],
    order: "asc",
    rows: 5,
    page: 1,
    total_pages: 0,
    loading: true,
}